import { FC } from 'react';
import { IOption } from 'components/elements';
import { CustomModal } from 'components/elements/CustomModal';
import { ICityAliasFormValues } from 'types';
import { CityAliasForm } from '../CityAliasForm';

interface ManageCityAliasModalProps {
	isOpen: boolean;
	onClose: () => void;
	initialValues: ICityAliasFormValues;
	onSubmit: (values: ICityAliasFormValues) => void;
	buttonText: string;
	title: string;
	cityOptions: IOption[];
	cityOptionsLoading: boolean;
	onCitySearch: (search: string) => void;
	onCityLoadMore: () => void;
	hasMoreCityOptions: boolean;
	initialCityTitle?: string;
	providerOptions: IOption[];
	onDeleteRequest?: () => void;
	canDelete?: boolean;
}

export const ManageCityAliasModal: FC<ManageCityAliasModalProps> = ({
	isOpen,
	onClose,
	initialValues,
	onSubmit,
	buttonText,
	title,
	cityOptions,
	cityOptionsLoading,
	onCitySearch,
	onCityLoadMore,
	hasMoreCityOptions,
	initialCityTitle,
	providerOptions,
	onDeleteRequest,
	canDelete = false,
}) => {
	return (
		<CustomModal open={isOpen} onClose={onClose} title={title} maxWidth="md" fullWidth>
			<CityAliasForm
				initialValues={initialValues}
				onSubmit={onSubmit}
				buttonText={buttonText}
				cityOptions={cityOptions}
				cityOptionsLoading={cityOptionsLoading}
				onCitySearch={onCitySearch}
				onCityLoadMore={onCityLoadMore}
				hasMoreCityOptions={hasMoreCityOptions}
				initialCityTitle={initialCityTitle}
				providerOptions={providerOptions}
				onDeleteRequest={onDeleteRequest}
				canDelete={canDelete}
			/>
		</CustomModal>
	);
};
